export default __webpack_public_path__ + "static/media/logo-callswitch-white.99ee688c.svg";